/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Excellent
 *
 * 2 = Good
 *
 * 3 = Average
 *
 * 4 = Poor
 */
export enum CarCondition {
  Excellent = 1,
  Good = 2,
  Average = 3,
  Poor = 4,
}
